import Entity from 'utilities/Entity';

class Page extends Entity {}

export default new Page();